// ======================================================================
// File: src/modules/ppe/components/orders/OrdersFilterBar.js
// ======================================================================

import React, { useState, useEffect } from "react";

export default function OrdersFilterBar({ filters, onApply }) {
  const [local, setLocal] = useState({
    q: "",
    status: "",
    from_date: "",
    to_date: "",
  });

  // Sync external reset
  useEffect(() => {
    setLocal({
      q: filters.q || "",
      status: filters.status || "",
      from_date: filters.from_date || "",
      to_date: filters.to_date || "",
    });
  }, [filters]);

  const update = (k, v) => setLocal({ ...local, [k]: v });

  return (
    <div className="card mb-3">
      <div className="card-body">
        <div className="d-flex flex-wrap align-items-end gap-2">

          {/* Search */}
          <div style={{ minWidth: 220 }}>
            <input
              className="form-control"
              placeholder="Search Order No / Customer"
              value={local.q}
              onChange={(e) => update("q", e.target.value)}
            />
          </div>

          {/* Status */}
          <div style={{ minWidth: 160 }}>
            <select
              className="form-select"
              value={local.status}
              onChange={(e) => update("status", e.target.value)}
            >
              <option value="">All Status</option>
              <option value="DRAFT">Draft</option>
              <option value="CONFIRMED">Confirmed</option>
              <option value="IN_PROGRESS">In Progress</option>
              <option value="COMPLETED">Completed</option>
            </select>
          </div>

          {/* From Date */}
          <div>
            <input
              type="date"
              className="form-control"
              value={local.from_date}
              onChange={(e) => update("from_date", e.target.value)}
            />
          </div>

          {/* To Date */}
          <div>
            <input
              type="date"
              className="form-control"
              value={local.to_date}
              onChange={(e) => update("to_date", e.target.value)}
            />
          </div>

          {/* Actions */}
          <div className="d-flex gap-2">
            <button
              className="btn btn-primary"
              onClick={() => onApply(local)}
            >
              Apply
            </button>

            <button
              className="btn btn-outline-secondary"
              onClick={() => onApply({})}
            >
              Reset
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}
